/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyle3dhint3Inputs */

const en_aiflowstyle3dhint3 = /** @type {(inputs: Aiflowstyle3dhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sculpted, glossy`)
};

const de_aiflowstyle3dhint3 = /** @type {(inputs: Aiflowstyle3dhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plastisch, glänzend`)
};

/**
* | output |
* | --- |
* | "Sculpted, glossy" |
*
* @param {Aiflowstyle3dhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyle3dhint3 = /** @type {((inputs?: Aiflowstyle3dhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyle3dhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyle3dhint3(inputs)
	return de_aiflowstyle3dhint3(inputs)
});
export { aiflowstyle3dhint3 as "aiFlowStyle3dHint" }